import { useRoute } from 'shared/src/hooks/useRoute';

export type GoodsRouteParams = {
  RecentlyViewedGoods: {
    instanceId?: string;
  };
};

export const useGoodsRoute = <Key extends keyof GoodsRouteParams>() =>
  useRoute<GoodsRouteParams, Key>();
